module.exports = __webpack_public_path__ + "img/cn_flag.214508bc.svg";